import styled from 'styled-components'

const SIZING = {
  container: {
    width: { s: 40, l: 50, m: 35 },
    height: { s: 22, l: 30, m: 20 }
  },
  round: {
    size: { s: 14, l: 20, m: 14 },
    top: { s: 4, l: 5, m: 3 },
    left: {
      checked: { s: 22, l: 25, m: 18 },
      unChecked: { s: 3, l: 5, m: 3 }
    }
  }
}

const Round = styled.div`
  position: absolute;
  left: ${p =>
    SIZING.round.left[p.checked ? 'checked' : 'unChecked'][p.size]}px;
  top: ${p => SIZING.round.top[p.size]}px;
  height: ${p => SIZING.round.size[p.size]}px;
  width: ${p => SIZING.round.size[p.size]}px;
  border-radius: 50%;
  background-color: ${p => p.theme.color.backgroundRush};
  transition: ${p => p.theme.duration.m} linear;
`

const SwitcherContainer = styled.div`
  position: relative;
  display: inline-block;
  width: ${p => SIZING.container.width[p.size]}px;
  height: ${p => SIZING.container.height[p.size]}px;
  border-radius: ${p => SIZING.container.height[p.size] / 2}px;
  background-color: ${p => p.checked ? p.theme.color.turquoise : p.theme.color.disabled};
  transition: ${p => p.theme.duration.m} linear;
  pointer-events: ${p => (p.disabled ? 'none' : 'auto')};

  &:hover {
    cursor: pointer;
  }
`

const ThemeSwitcherContainer = styled(SwitcherContainer)`
  background-color: ${p => p.checked ? '#0E5E8C' : p.theme.color.turquoise};
  
  span {
    display: flex;
    position: absolute;
    left: ${p => (p.checked ? '4px' : '20px')};
    top: 3px;
    transform: ${p => (p.checked ? 'scaleX(-1)' : 'scaleX(1)')};
    transition: ${p => p.theme.duration.m} linear;
    opacity: ${p => (p.checked ? '0.1' : '1')};

    svg {
      width: 16px;
      height: 15px;
      fill: ${p => p.theme.color.white};
    }
  }
`

const ThemeRound = styled(Round)`
  background-color: ${p => p.checked ? '#A59DD1' : '#FFE600'};
`


export const Styled = {
  Round,
  ThemeRound,
  SwitcherContainer,
  ThemeSwitcherContainer
}
